import { Member, MemberResponse } from '../../models/ClubManagement';

const serializeMember = ({ inClubSince, ...rest }: MemberResponse): Member => ({
  ...(inClubSince && { inClubSince }),
  ...rest,
});

export default serializeMember;
